/**
 * Copyright 2020 ExpediaGroup. All rights reserved.
 * EXPEDIA PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

const DomainToLocaleMap = Object.freeze({
  'ar.hoteles.com': 'es_AR',
  'ar.hotels.com': 'ar_AE',
  'at.hotels.com': 'de_AT',
  'au.hotels.com': 'en_AU',
  'ca.hotels.com': 'en_CA',
  'ch.hotels.com': 'de_CH',
  'co.hoteles.com': 'es_ES',
  'cs.hotels.com': 'cs_CZ',
  'da.hotels.com': 'da_DK',
  'de.hotels.com': 'de_DE',
  'el.hotels.com': 'el_GR',
  'es.hoteles.com': 'es_ES',
  'es.hotels.com': 'es_ES',
  'et.hotels.com': 'et_EE',
  'fi.hotels.com': 'fi_FI',
  'fr.hotels.com': 'fr_FR',
  'he.hotels.com': 'iw_IL',
  'hr.hotels.com': 'hr_HR',
  'hu.hotels.com': 'hu_HU',
  'id.hotels.com': 'in_ID',
  'ie.hotels.com': 'en_IE',
  'in.hotels.com': 'en_IN',
  'is.hotels.com': 'is_IS',
  'it.hotels.com': 'it_IT',
  'jp.hotels.com': 'ja_JP',
  'kr.hotels.com': 'ko_KR',
  'lt.hotels.com': 'lt_LT',
  'lv.hotels.com': 'lv_LV',
  'ms.hotels.com': 'ms_MY',
  'nl.hotels.com': 'nl_NL',
  'no.hotels.com': 'no_NO',
  'nz.hotels.com': 'en_NZ',
  'ph.hotels.com': 'en_PH',
  'pl.hotels.com': 'pl_PL',
  'pt.hoteis.com': 'pt_PT',
  'ru.hotels.com': 'ru_RU',
  'sg.hotels.com': 'en_SG',
  'sk.hotels.com': 'sk_SK',
  'sv.hotels.com': 'sv_SE',
  'th.hotels.com': 'th_TH',
  'tr.hotels.com': 'tr_TR',
  'tw.hotels.com': 'zh_TW',
  'ua.hotels.com': 'uk_UA',
  'uk.hotels.com': 'en_GB',
  'vi.hotels.com': 'vi_VN',
  'www.hoteis.com': 'pt_BR',
  'www.hoteles.com': 'es_ES',
  'www.hotels.cn': 'zh_CN',
  'www.hotels.com': 'en_US',
  'za.hotels.com': 'en_ZA',
  'zh.hotels.com': 'zh_HK',
});
export default DomainToLocaleMap;
